import React, { useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'

const AREAS = ['health','mind','career','relationships','faith','purpose']

function todayStr() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
}

export default function AddGoalPage({ onNavigate }) {
  const { user } = useAuth()
  const [title, setTitle] = useState('')
  const [startVal, setStartVal] = useState('')
  const [goalVal, setGoalVal] = useState('')
  const [deadline, setDeadline] = useState(todayStr())
  const [area, setArea] = useState('purpose')
  const [saving, setSaving] = useState(false)

  const canSave = title.trim() && goalVal

  async function save() {
    if (!canSave || saving) return
    setSaving(true)
    await supabase.from('goals').insert({
      user_id: user.id,
      title: title.trim(),
      area,
      start_value: Number(startVal) || 0,
      goal_value: Number(goalVal),
      current_value: Number(startVal) || 0,
      deadline: deadline || null,
    })
    setSaving(false)
    onNavigate('dashboard')
  }

  return (
    <div style={s.overlay}>
      <div style={s.box}>
        <div style={s.header}>
          <div style={s.title}>Start a Goal</div>
          <div style={s.close} onClick={() => onNavigate('dashboard')}>✕</div>
        </div>

        <div style={s.hint}>What do you want to achieve?</div>

        <input style={s.input} placeholder="Goal title" value={title}
          onChange={e => setTitle(e.target.value)} autoFocus />

        <div style={s.row}>
          <input style={{ ...s.input, flex: 1 }} type="number" placeholder="Start"
            value={startVal} onChange={e => setStartVal(e.target.value)} />
          <input style={{ ...s.input, flex: 1 }} type="number" placeholder="Target"
            value={goalVal} onChange={e => setGoalVal(e.target.value)} />
        </div>

        <input style={s.input} type="date" value={deadline}
          onChange={e => setDeadline(e.target.value)} />

        <select style={s.input} value={area} onChange={e => setArea(e.target.value)}>
          {AREAS.map(a => <option key={a} value={a}>{a.charAt(0).toUpperCase() + a.slice(1)}</option>)}
        </select>

        <div style={{ ...s.btn, opacity: canSave ? 1 : 0.4 }} onClick={save}>
          {saving ? 'Saving...' : 'Create Goal →'}
        </div>
      </div>
    </div>
  )
}

const s = {
  overlay: { position: 'fixed', inset: 0, zIndex: 600, backdropFilter: 'blur(8px)', background: 'rgba(13,13,20,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' },
  box: { background: '#1a1a26', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '20px', padding: '24px', width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: '12px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '2px', color: '#e8e6df' },
  close: { fontSize: '18px', color: '#6b6860', cursor: 'pointer', padding: '4px' },
  hint: { fontSize: '13px', color: '#6b6860', marginTop: '-4px' },
  input: { width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '12px', padding: '13px 14px', color: '#e8e6df', fontSize: '15px', fontFamily: "'DM Sans', sans-serif", outline: 'none', boxSizing: 'border-box', appearance: 'none', WebkitAppearance: 'none' },
  row: { display: 'flex', gap: '10px' },
  btn: { padding: '14px', background: 'linear-gradient(135deg, #c9a84c, #8b6a1a)', color: '#000', borderRadius: '12px', textAlign: 'center', cursor: 'pointer', fontSize: '15px', fontWeight: '700', marginTop: '4px' },
}
